<template>
    <div
        class="o-dropdown-select"
    >
        <ODropdownItemsType
            v-model="dropdownType"
            :label="$t('ui.start-2')"
        />
        <OStartItemsDropdown
            v-show="dropdownType"
            :value="startObjectId"
            :isShowLabel="false"
            :dropdownType="dropdownType"
            :placeholder="dropdownPlaceholder"
            @onChangeStart="onChangeStart"
            ref="startItemDropdown"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ODropdownItemsType from '../../organisms/o-dropdown-items-type';
import OStartItemsDropdown from '../../organisms/o-start-items-dropdown';

export default {
    name: 'ODropdownSelect',
    props: {
        startObjectId: {
            type: [Number, String],
            default: ''
        }
    },
    components: {
        ODropdownItemsType,
        OStartItemsDropdown
    },
    data() {
        return {
            dropdownType: ''
        }
    },
    watch: {
        dropdownType(type) {
            if(this.startObjectDropdownType && type !== this.startObjectDropdownType) {
                this.$nextTick(() => {
                    this.$refs.startItemDropdown.clearSelect();
                })
            }
        }
    },
    computed: {
        ...mapGetters([
            'getDenormalisedObjectById'
        ]),
        startObjectType() {
            return this.startObjectId ? this.getDenormalisedObjectById(this.startObjectId)?.type : ''
        },
        startObjectDropdownType() {
            if(this.startObjectType) {
                if(this.startObjectType == 'tenant') {
                    return 'tenants'
                }
                if(this.startObjectType == 'portal' || this.startObjectType == 'entrance') {
                    return 'entrances'
                }
            }
            return ''
        },
        dropdownPlaceholder() {
            if(this.dropdownType == 'tenants') {
                return this.$t('ui.select_tenants', 'Select')
            } else if(this.dropdownType == 'entrances') {
                return this.$t('ui.select_entrances', 'Select')
            }
            return ''
        }
    },
    methods: {
        onChangeStart(data) {
            this.$emit('onChangeStart', data)
        }
    },
    created() {
        if(this.startObjectDropdownType) {
            this.dropdownType = this.startObjectDropdownType;
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
